var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBonusesDateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3332 12C12.3332 12.1833 12.1832 12.3333 11.9998 12.3333H1.99984C1.8165 12.3333 1.6665 12.1833 1.6665 12V5.33333C1.6665 5.15 1.8165 5 1.99984 5H11.9998C12.1832 5 12.3332 5.15 12.3332 5.33333V12ZM12.3333 1.66667H11.6667V1C11.6667 0.446667 11.22 0 10.6667 0C10.1133 0 9.66667 0.446667 9.66667 1V1.66667H4.33333V1C4.33333 0.446667 3.88667 0 3.33333 0C2.78 0 2.33333 0.446667 2.33333 1V1.66667H1.66667C0.746667 1.66667 0 2.41333 0 3.33333V12.3333C0 13.2533 0.746667 14 1.66667 14H12.3333C13.2533 14 14 13.2533 14 12.3333V3.33333C14 2.41333 13.2533 1.66667 12.3333 1.66667Z",
    fill: "#283542"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66683 7.33317C4.66683 7.70317 4.36816 7.99984 4.00016 7.99984C3.63183 7.99984 3.3335 7.70317 3.3335 7.33317C3.3335 6.9665 3.63183 6.6665 4.00016 6.6665C4.36816 6.6665 4.66683 6.9665 4.66683 7.33317Z",
    fill: "#283542"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66683 10.0002C4.66683 10.3702 4.36816 10.6668 4.00016 10.6668C3.63183 10.6668 3.3335 10.3702 3.3335 10.0002C3.3335 9.6335 3.63183 9.3335 4.00016 9.3335C4.36816 9.3335 4.66683 9.6335 4.66683 10.0002Z",
    fill: "#283542"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66683 7.33317C7.66683 7.70317 7.36816 7.99984 7.00016 7.99984C6.63183 7.99984 6.3335 7.70317 6.3335 7.33317C6.3335 6.9665 6.63183 6.6665 7.00016 6.6665C7.36816 6.6665 7.66683 6.9665 7.66683 7.33317Z",
    fill: "#283542"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66683 10.0002C7.66683 10.3702 7.36816 10.6668 7.00016 10.6668C6.63183 10.6668 6.3335 10.3702 6.3335 10.0002C6.3335 9.6335 6.63183 9.3335 7.00016 9.3335C7.36816 9.3335 7.66683 9.6335 7.66683 10.0002Z",
    fill: "#283542"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6668 7.33317C10.6668 7.70317 10.3682 7.99984 10.0002 7.99984C9.63183 7.99984 9.3335 7.70317 9.3335 7.33317C9.3335 6.9665 9.63183 6.6665 10.0002 6.6665C10.3682 6.6665 10.6668 6.9665 10.6668 7.33317Z",
    fill: "#283542"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6668 10.0002C10.6668 10.3702 10.3682 10.6668 10.0002 10.6668C9.63183 10.6668 9.3335 10.3702 9.3335 10.0002C9.3335 9.6335 9.63183 9.3335 10.0002 9.3335C10.3682 9.3335 10.6668 9.6335 10.6668 10.0002Z",
    fill: "#283542"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusesDateIcon);
export default __webpack_public_path__ + "static/media/bonusesDateIcon.da18c55292acdf533be6949dccd3cc15.svg";
export { ForwardRef as ReactComponent };